import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import type React from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  verticalLine: {
    borderLeft: `1px solid ${theme.palette.divider}`,
    height: '26px',
    marginRight: '12px',
    marginLeft: '12px',
  },
}));

const VerticalLine: React.FC = () => {
  const classes = useStyles();
  return <div className={classes.verticalLine}></div>;
};

export default VerticalLine;
